import { Pencil, Trash2, Eye } from 'lucide-react'
import { Button } from '@components/Button/Button'
import { useTranslations } from '../providers/ContactServiceProvider'

interface ContactRowActionsProps {
  contactId: string
  mode: 'edit' | 'view'
  isPendingDelete: boolean
  onEdit: (id: string) => void
  onView: (id: string) => void
  onDelete: (id: string) => void
  onRestore: (id: string) => void
}

export function ContactRowActions({
  contactId,
  mode,
  isPendingDelete,
  onEdit,
  onView,
  onDelete,
  onRestore,
}: ContactRowActionsProps) {
  const t = useTranslations()

  // AC6: Deleted row — only "Deshacer" outline button. Centered (not justify-end) so it
  // lines up under the now-centered "Acciones" header label.
  if (isPendingDelete) {
    return (
      <div className="flex items-center justify-center">
        <Button
          type="outline"
          size="xs"
          onClick={() => onRestore(contactId)}
        >
          {t.actions.undo}
        </Button>
      </div>
    )
  }

  // AC5: Actions always visible — no hover behavior
  if (mode === 'view') {
    return (
      <div className="flex items-center justify-center gap-1.5">
        <Button
          type="outline"
          size="xs"
          iconOnly
          leftIcon={<Eye className="h-4 w-4" />}
          onClick={() => onView(contactId)}
          ariaLabel={t.actions.viewDetail}
        />
      </div>
    )
  }

  return (
    <div className="flex items-center justify-center gap-1.5">
      <Button
        type="outline"
        size="xs"
        iconOnly
        leftIcon={<Pencil className="h-4 w-4" />}
        onClick={() => onEdit(contactId)}
        ariaLabel={t.actions.edit}
      />
      <Button
        type="outline"
        size="xs"
        iconOnly
        leftIcon={<Eye className="h-4 w-4" />}
        onClick={() => onView(contactId)}
        ariaLabel={t.actions.viewDetail}
      />
      <Button
        type="outline"
        size="xs"
        iconOnly
        leftIcon={<Trash2 className="h-4 w-4 text-content-extensions-red" />}
        onClick={() => onDelete(contactId)}
        ariaLabel={t.actions.delete}
      />
    </div>
  )
}
